(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/team-names.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/team-names.js');
"use strict";

const {
  useGetParticipantName
} = svs.components.tipsen.hooks;
const {
  ParticipantsNames
} = svs.components.lbUi.participants;
const TeamNames = _ref => {
  let {
    productId,
    drawNumber,
    drawEventNumber,
    nameSize
  } = _ref;
  const [homeParticipant, awayParticipant] = useGetParticipantName(productId, drawNumber, drawEventNumber);
  return React.createElement(ParticipantsNames, {
    awayParticipant: awayParticipant,
    homeParticipant: homeParticipant,
    nameSize: nameSize
  });
};
setGlobal('svs.components.tipsen.couponStatic.TeamNames', TeamNames);

 })(window);